/**
 * Computes the left margin for a given node depth in the tree.
 * @param offset Additional margin to include.
 */
export function leftMarginForDepth(depth: number, offset: number = 0) {
  return `${offset + depth * 1.5}rem`;
}
